export function recoveringJsonParse(
  value: string | null | undefined
): any | null {
  try {
    return (value && JSON.parse(value)) || null
  } catch (e) {
    return null
  }
}
